import VueRouter from "vue-router";
// 关闭重复跳页面报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
// 页面
import routerLab from '@/view/routerLab';
import login from '@/view/auth/login';
import home from '@/view/home/home';
import smallBag from '@/view/home/smallBag';
import smallBagMsg from '@/view/home/smallBagMsg';
import maitouList from '@/view/home/maitouList';
import bigBag from '@/view/home/bigBag';
import bigBagMsg from '@/view/home/bigBagMsg';
import carMsg from '@/view/home/carMsg';
import daoru from '@/view/home/daoru';
import tableList from '@/view/home/tableList';
import uinfo from '@/view/home/uinfo';


// 路由
export default new VueRouter({
    routes:[
        {
            path:'/',
            component:routerLab,
			redirect: '/login',
			children:[
				{
					path: 'login',
					component: login,
				},
				{
					path: 'home',
					component: home,
				},
				{
					path: 'smallBag',
					component: smallBag,
				},
				{
					path: 'smallBagMsg',
					component: smallBagMsg,
				},
				{
					path: 'maitouList',
					component: maitouList,
				},
				{
					path: 'bigBag',
					component: bigBag,
				},
				{
					path: 'bigBagMsg',
					component: bigBagMsg,
				},
				{
					path: 'carMsg',
					component: carMsg,
				},
				{
					path: 'daoru',
					component: daoru,
				},
				{
					path: 'tableList',
					component: tableList,
				},
				{
					path: 'uinfo',
					component: uinfo,
				}
				
				
			]
        }
    ]
})
